// extracted by mini-css-extract-plugin
module.exports = {"container":"Availabilities_container__1izf8","download-button":"Availabilities_download-button__2xVE4"};